import { AuthActionType, LsKeys, Roles } from 'enums';
import { AuthActionReturnType } from 'state/actions';
import { AuthStateType, UserType } from 'state/reducers/auth/types';
import { restoreState } from 'utils';

const initState: AuthStateType = {
  fullLoading: false,
  loading: false,
  error: null,
  accessToken: restoreState(LsKeys.TOKEN_INFO)?.accessToken ?? '',
  refreshToken: restoreState(LsKeys.TOKEN_INFO)?.refreshToken ?? '',
  notification: '',
  recoveryToken: '',
  user: restoreState(LsKeys.USER_INFO) ?? ({} as UserType),
  tenant:
    restoreState(LsKeys.USER_INFO)?.role === Roles.SUPER_ADMIN
      ? 'admin'
      : restoreState(LsKeys.USER_INFO)?.company?.id ?? '',
};

export const authReducer = (
  // eslint-disable-next-line default-param-last
  state: AuthStateType = initState,
  action: AuthActionReturnType,
): AuthStateType => {
  switch (action.type) {
    case AuthActionType.FULL_LOADING:
      return { ...state, fullLoading: action.fullLoading };
    case AuthActionType.LOADING:
      return { ...state, loading: action.loading };
    case AuthActionType.LOG_IN:
      return {
        ...state,
        accessToken: action.data.accessToken,
        refreshToken: action.data.refreshToken,
        error: null,
      };
    case AuthActionType.ERROR:
      return { ...state, error: action.message };
    case AuthActionType.SET_NOTIFICATION:
      return { ...state, notification: action.notification };
    case AuthActionType.LOG_OUT:
      return { ...state, accessToken: '', refreshToken: '', user: {} as UserType };
    case AuthActionType.SET_RECOVERY_TOKEN:
      return { ...state, recoveryToken: action.token };
    case AuthActionType.GET_USER_INFO:
      return { ...state, user: action.user };
    case AuthActionType.SET_TENANT:
      return { ...state, tenant: action.tenant };
    default:
      return state;
  }
};
